import React from 'react';
import { DateTime, Duration } from 'luxon';
import { Row, Col } from 'react-bootstrap';
import { RichText } from 'prismic-reactjs';
import Layout from '../components/Layout';
import OpenGraphTitle from '../components/OpenGraphTitle';
import OpenGraphDescription from '../components/OpenGraphDescription';
import Head from '../components/head';
import Section from '../components/Section';
import PageTitle from '../components/PageTitle';
import { FranchiseeProvider } from '../context/Franchisee';
import { PrismicClient } from '../SDKs/Prismic/prismic.config';
import htmlSerializer from '../SDKs/Prismic/htmlSerializer';

export const getStaticProps = async (context) => {
  const { req } = context;
  const privacyPolicy = await PrismicClient(req).getSingle(
    'privacy-policy',
    {}
  );
  const revalidate = Duration.fromObject({ days: 1 }).as('seconds');

  return {
    props: {
      privacyPolicy,
    },
    revalidate,
  };
};

interface PrivacyPolicyPageProps {
  /* add privacy policy page props here */
  privacyPolicy: any;
}

const PrivacyPolicy: React.FC<PrivacyPolicyPageProps> = ({
  privacyPolicy,
}: PrivacyPolicyPageProps) => {
  const lastUpdated = DateTime.fromISO(privacyPolicy.last_publication_date);

  const { content } = privacyPolicy.data;
  return (
    <FranchiseeProvider>
      <Layout alternateFooter>
        <Head
          slug='privacy-policy'
          title='Privacy Policy - Two Maids Professional Cleaning Services'
          description={`We’re dedicated to safeguarding your personal information & privacy within our professional deep cleaning services.`}
        />
        <OpenGraphTitle title='Privacy Policy - Two Maids Professional Cleaning Services' />
        <OpenGraphDescription>
          {/* Add Privacy Policy description here */}
          We’re dedicated to safeguarding your personal information & privacy within our professional deep cleaning services.
        </OpenGraphDescription>
        <Section>
          <Row className='justify-content-center'>
            <Col xs={12} lg={10} xl={9}>
              <div className='mb-3'>
                <PageTitle>Home Franchise Concepts Privacy Policy</PageTitle>
                <span className='text-uppercase font-weight-bold'>
                  Effective Date {lastUpdated.toLocaleString(DateTime.DATE_FULL)}
                </span>
              </div>
              <RichText render={content} htmlSerializer={htmlSerializer} />
            </Col>
          </Row>
        </Section>
      </Layout>
    </FranchiseeProvider>
  );
};

export default PrivacyPolicy;
